import { PanelMode } from "contexts/panelMode/types";
import { UxFlavor } from "slices/explorer/types";

export type PresentationTarget = "window" | "sidePanel" | "drawer";

/**
 * Resolves the presentation target for window API calls based on the current
 * UX flavor and panel mode. Desktop flavors always use floating windows;
 * mobile flavors delegate to either side panels or drawers depending on the
 * live panel mode (which can flip on device rotation / resize).
 */
export function resolvePresentationTarget(uxFlavor: UxFlavor, panelMode: PanelMode): PresentationTarget {
    if (uxFlavor === UxFlavor.ProcoreAndroid || uxFlavor === UxFlavor.ProcoreIOS) {
        return panelMode;
    }
    return "window";
}

export function isMobileUxFlavor(uxFlavor: UxFlavor): boolean {
    return uxFlavor === UxFlavor.ProcoreAndroid || uxFlavor === UxFlavor.ProcoreIOS;
}
